<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem?.displayName }} [{{ currentItem?.code }}]</h2>
      </div>
      <div *ngIf="manageAgency">
        <action-bar [showSave]="true" [showDelete]="currentItem && currentItem.agencyId" (onSave)="clickSave(form?.value)" (onDelete)="openDialogDelete(currentItem.agencyId!)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="10" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'agency_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="256" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 256</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'agency_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_parent' | translate }}</mat-label>
                <input matInput formControlName="parent" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="fdes-scope">
        <div class="seve-card fdes-rdf-card">
          <div class="seve-card__head">
            <span class="seve-eyebrow-ic seve-eyebrow-ic--green"><mat-icon>eco</mat-icon></span>
            <span class="seve-eyebrow seve-eyebrow--green">{{ 'agency_rdf_eyebrow' | translate }}</span>
          </div>
          <div class="seve-card__body">
            <div class="fdes-rdf">
              <span class="seve-badge seve-badge--success" *ngIf="rdfAdherent"><span class="seve-badge__dot"></span>{{ 'agency_rdf_badge_member' | translate }}</span>
              <span class="seve-badge seve-badge--neutral" *ngIf="!rdfAdherent"><span class="seve-badge__dot"></span>{{ 'agency_rdf_badge_non_member' | translate }}</span>
              <p class="fdes-rdf__note"><mat-icon>lock</mat-icon>{{ 'agency_rdf_note' | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="title-margin-top">
        <h3>{{ 'agency_section_address' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-4">
              <mat-form-field>
                <mat-label color="accent">{{ 'agency_field_address_line1' | translate }}</mat-label>
                <input formControlName="address_L3" matInput />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <mat-label color="accent">{{ 'agency_field_address_line2' | translate }}</mat-label>
                <input formControlName="address_L4" matInput />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <mat-label color="accent">{{ 'agency_field_address_line3' | translate }}</mat-label>
                <input formControlName="address_L5" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <mat-form-field>
                <mat-label color="accent">{{ 'agency_field_postal_code' | translate }}</mat-label>
                <input matInput formControlName="address_PC" type="number" />
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'agency_field_city' | translate }}</mat-label>
                <input matInput formControlName="address_Location" />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</div>
